import { OptionItem } from "commons/ultilities/dynamic-form/models/control";

export const mapToDistinctOptionItems = <T>(
  items: T[] | null | undefined,
  valueSelector: (item: T) => string | number | null | undefined,
  labelSelector?: (item: T) => string | number | null | undefined,
): OptionItem[] => {
  const optionItems =
    items?.map((item) => {
      const value = String(valueSelector(item) ?? "");
      const label = String(labelSelector?.(item) ?? value);

      return {
        value,
        label,
      };
    }) ?? [];

  const uniqueOptions = new Map<string, OptionItem>();
  optionItems.forEach((option) => {
    const key = `${option.value}|${option.label}`;
    if (!uniqueOptions.has(key)) {
      uniqueOptions.set(key, option);
    }
  });

  return Array.from(uniqueOptions.values());
};


